import React from 'react';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import WorkIcon from '@material-ui/icons/Work';
import Link from '@material-ui/core/Link';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { memberInfos } from './memberInfos';
import {
  StyledFlexGrid,
  StyledCard,
  StyledFlexContainer,
  StyledInfoContainer,
  StyledButtonContainer,
} from './Contributors.styled';

const useStyles = makeStyles((theme) => ({
  large: {
    width: 180,
    height: 180,
  },
}));

const Contributors = (props) => {
  const classes = useStyles();
  return (
    <Grid container spacing={2} justify='center' alignItems='center'>
      {memberInfos.map((memberInfo) => (
        <StyledFlexGrid item md={4} sm={6} xs={12} key={memberInfo.image}>
          <StyledCard
            style={{ width: 300, position: 'relative' }}
            // className='card-container-dark'
          >
            <StyledFlexContainer style={{ marginTop: 8 }}>
              <Avatar
                alt='avatar'
                src={memberInfo.image}
                className={classes.large}
              />
            </StyledFlexContainer>
            <CardContent>
              <StyledInfoContainer>
                <AccountCircleIcon />
                <Typography
                  variant='body2'
                  component='p'
                  style={{ marginLeft: 8 }}
                >
                  <strong>{memberInfo.name}</strong>
                </Typography>
              </StyledInfoContainer>

              <StyledInfoContainer>
                <WorkIcon />
                <Link
                  href={memberInfo.workLink}
                  color='inherit'
                  variant='body2'
                  style={{ marginLeft: 8 }}
                  target='_blank'
                >
                  {memberInfo.work}
                </Link>
              </StyledInfoContainer>

              <StyledInfoContainer style={{ overflowWrap: 'break-word' }}>
                <EmailIcon />
                <Typography
                  variant='body2'
                  component='p'
                  style={{ marginLeft: 8 }}
                >
                  {memberInfo.email}
                </Typography>
              </StyledInfoContainer>

              {memberInfo.phone && (
                <StyledInfoContainer>
                  <PhoneIcon />
                  <Typography
                    variant='body2'
                    component='p'
                    style={{ marginLeft: 8 }}
                  >
                    {memberInfo.phone}
                  </Typography>
                </StyledInfoContainer>
              )}
            </CardContent>
            <StyledButtonContainer>
              <Button
                size='small'
                color='primary'
                href={memberInfo.webLink && memberInfo.webLink}
                target='_blank'
              >
                View More
              </Button>
            </StyledButtonContainer>
          </StyledCard>
        </StyledFlexGrid>
      ))}
    </Grid>
  );
};

export default Contributors;
